import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
const ScrollContainer = memo(({ children, className, id, startScrollToTopDate, startScrollToDownDate }) => {
    const containerRef = useRef(null);
    const bottomRef = useRef(null);
    const [isShowScroll, setIsShowScroll] = useState(false);
    const scrollToTop = useCallback(() => {
        if (containerRef && containerRef.current) {
            containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [containerRef]);
    const scrollToBottom = useCallback(() => {
        if (bottomRef && bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [bottomRef]);
    useEffect(() => {
        if (startScrollToTopDate) {
            scrollToTop();
        }
    }, [scrollToTop, startScrollToTopDate]);
    useEffect(() => {
        if (startScrollToDownDate) {
            scrollToBottom();
        }
    }, [scrollToBottom, startScrollToDownDate]);
    return (React.createElement("div", { ref: containerRef, className: 'ac-scroll-container custom-scroll ' + (isShowScroll ? ' is-show ' : '') + (className ? className : ''), id: id, onMouseEnter: () => {
            setIsShowScroll(true);
        }, onMouseLeave: () => {
            setIsShowScroll(false);
        } },
        children,
        React.createElement("div", { ref: bottomRef })));
});
export { ScrollContainer };
//# sourceMappingURL=ScrollContainer.js.map